import { BaseFormatEvent } from '../base-format-event.model';

export class PreloadErrorEvent extends BaseFormatEvent {
  constructor() {
    super('preload-error');
  }
}
